import React, { useCallback, useEffect, useState } from "react";
import { Card, Col, Row, Table, Tabs, Tab, Badge, Dropdown, Modal, Form, Button } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Lottie from "lottie-react";
import animationData from "../../images/loding.json";
import Pagination from "../components/Pagination";
import { addCohost, blockUser, deleteUsers, getSUBSCRIPTION, getUserList, createHost, changeRequestUserPlan, postNewWeddingRequest } from "../../services/UserServices/UserService";
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";
import debounce from "lodash/debounce";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import { getUserGuestsList } from "../../services/UserServices/UserService";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import * as Yup from "yup";
import { set } from "lodash";
import ConfirmDeleteModal from "../Modals/ConfirmDelete";
import { Eye, Info } from "lucide-react";
export default function JobPosting(props) {
  const navigate = useNavigate();
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [loader, setLoader] = useState(true);

  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [jobId, setJobId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [endDate, setEndDate] = useState("")
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [isBlocked, setIsBlocked] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("host");
  const [guestList, setGuestList] = useState([]);
  const [sortByPlan, setSortByPlan] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [subscriptions, setSubscriptions] = useState([]);
  const [showAddHostModal, setShowAddHostModal] = useState(false);
  const [sortStatus, setSortStatus] = useState("");
  const [userType, setUserType] = useState("users");
  //add cohost
  const [showCoHostModal, setShowCoHostModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const [showHostModal, setShowHostModal] = useState(false);
  const [guestHosts, setGuestHosts] = useState([]);
  const [selectedGuestName, setSelectedGuestName] = useState("");

  const getHostName = (item) => {
    const name = item?.host?.hostName || item?.host?.name || item?.hostName || item?.name;
    if (!name) return null;
    const str = String(name).trim();
    if (str === "" || str.toLowerCase() === "null" || str.toLowerCase() === "undefined") return null;
    return str;
  };

  const [showAssignPlanModal, setShowAssignPlanModal] = useState(false);
  const [selectedUserForPlan, setSelectedUserForPlan] = useState(null);
  const [assignPlanId, setAssignPlanId] = useState("");
  const [assignPlanLoading, setAssignPlanLoading] = useState(false);
  const [newWeddingLoading, setNewWeddingLoading] = useState(false);
  const [planModalType, setPlanModalType] = useState("upgrade");


  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );



  const fetchSubscription = async () => {
    try {
      setLoader(true)
      const res = await getSUBSCRIPTION();
      setSubscriptions(res?.data?.data);

    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    } finally {
      setLoader(false)
    }
  };
  useEffect(() => {

    fetchSubscription()
  }, []);




  async function handleTableList() {


    try {

      if (activeTab === "host") {
        const res = await getUserList(currentPage, 10, search, sortByPlan, filterDate, endDate, "enabled", sortBy, sortBy ? sortOrder : "", userType);
        setTableData(res?.data?.data?.users);
        setTotalItems(res?.data?.data.count);
      }
      else {

        const res = await getUserGuestsList(currentPage, 10, search, filterDate, endDate, sortBy, sortBy ? sortOrder : "");
        setGuestList(res?.data?.data?.guests);
        setTotalItems(res?.data?.data.count)

      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoader(false);
    }
  }


  useEffect(() => {
    setLoader(true);
    setSearch("")
    setCurrentPage(0)
    setFilterDate("")
    setEndDate("")
    setSortByPlan("")
    setSortStatus("")
    setSortBy("")
    setSortOrder("asc")
    setUserType("users")
  }, [activeTab])

  const handleTableListDebounced = useCallback(
    debounce(() => {
      setLoader(true);
      handleTableList();
    }, 400),
    [search, currentPage, activeTab, sortByPlan, filterDate, sortStatus, endDate, sortBy, sortOrder, userType]
  );

  useEffect(() => {

    handleTableListDebounced();
    return () => handleTableListDebounced.cancel();
  }, [search, currentPage, activeTab, sortByPlan, filterDate, sortStatus, endDate, sortBy, sortOrder, userType]);



  useEffect(() => {
    setCurrentPage(0);
  }, [search, filterDate, sortByPlan, sortStatus, endDate, sortBy, sortOrder, userType]);

  useEffect(() => {
    if (activeTab === "host") {
      setGuestList([]);
    } else {
      setTableData([]);
    }
  }, [activeTab]);



  async function handleBlockComponent() {
    setActionLoading(true);
    try {
      await blockUser({ userId: jobId, isBlocked });
      handleTableList();
      setDeleteAccount(false);
      toast.success("User blocked successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setActionLoading(false);
    }
  }

  async function handleUnblockComponent(id) {
    setActionLoading(true);
    try {
      await blockUser({ userId: id, isBlocked: false });
      handleTableList();
      setDeleteAccount(false);
      toast.success("User unblocked successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setActionLoading(false);
    }
  }

  const handleDelete = async () => {
    try {
      setDeleting(true);
      await deleteUsers(deleteId);
      toast.success("Deleted successfully");
      setShowDeleteModal(false);
      setDeleteId(null);
      handleTableList();
    } catch (error) {
      toast.error("Error while deleting ");
    } finally {
      setDeleting(false);
    }
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleHeaderSort = (field) => {
    if (sortBy === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortBy(field);
      setSortOrder("asc");
    }
  };

  const renderTable = (data) => (
    <Card className="qx-table-card">
      <Card.Body>
        {activeTab === "host" && (
          <div className="p-3 bg-light border-bottom d-flex align-items-center gap-2 text-secondary small fw-medium" style={{ fontSize: "0.83rem" }}>
            <Info size={16} className="text-secondary flex-shrink-0" />
            <span>
              {userType === "partnerHost"
                ? "This table shows hosts created by partners."
                : userType === "createdByAdmin"
                  ? "This table shows hosts created by admin."
                  : "This table shows all hosts, including hosts registered via app and created by admin."}
            </span>
          </div>
        )}
        <Table responsive hover className="mb-0">
          <thead>
            <tr>
              <th><strong>S.NO</strong></th>
              <th
                onClick={() => handleHeaderSort("hostName")}
                style={{ cursor: "pointer", userSelect: "none" }}
              >
                <strong>
                  Name {sortBy === "hostName" ? (sortOrder === "asc" ? "↑" : "↓") : "↕"}
                </strong>
              </th>
              <th
                onClick={() => handleHeaderSort("phoneNumber")}
                style={{ cursor: "pointer", userSelect: "none" }}
              >
                <strong>
                  Phone Number {sortBy === "phoneNumber" ? (sortOrder === "asc" ? "↑" : "↓") : "↕"}
                </strong>
              </th>
              {activeTab === "host" && userType === "partnerHost" ? (
                <th>
                  <strong>Partner Name</strong>
                </th>
              ) : null}
              {activeTab === "host" ? (
                <th
                  onClick={() => handleHeaderSort("plan.name")}
                  style={{ cursor: "pointer", userSelect: "none" }}
                >
                  <strong>
                    Plan {sortBy === "plan.name" ? (sortOrder === "asc" ? "↑" : "↓") : "↕"}
                  </strong>
                </th>
              ) : ""}

              <th
                onClick={() => handleHeaderSort("createdAt")}
                style={{ cursor: "pointer", userSelect: "none" }}
              >
                <strong>
                  Registration Date {sortBy === "createdAt" ? (sortOrder === "asc" ? "↑" : "↓") : "↕"}
                </strong>
              </th>

              {activeTab === "host" && userType === "users" ? <th><strong>Plan Assiged By</strong></th> : ""}
              {activeTab === "host" ? <th><strong></strong></th> : ""}

              {activeTab === "guest" ? (
                <th
                  onClick={() => handleHeaderSort("hostName")}
                  style={{ cursor: "pointer", userSelect: "none" }}
                >
                  <strong>
                    Host Name {sortBy === "hostName" ? (sortOrder === "asc" ? "↑" : "↓") : "↕"}
                  </strong>
                </th>
              ) : ""}


              {activeTab === "host" ? <th><strong>Action</strong></th> : ""}
            </tr>
          </thead>
          <tbody>
            {data.map((user, index) => (
              <tr style={{ color: "#A60000" }} key={user._id}>
                <td>{index + 1 + currentPage * itemsPerPage}</td>
                <td>{user.name || user.hostName || "_"}</td>

                <td>{`${user.countryCode} ${user.phoneNumber}`}</td>
                {activeTab === "host" && userType === "partnerHost" ? (
                  <td>
                    {user?.partnerId ? (
                      <span
                        className="fw-bold"
                        style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
                        onClick={() => {
                          const pId = typeof user.partnerId === "object" && user.partnerId !== null ? user.partnerId._id || user.partnerId.id : user.partnerId;
                          if (pId) {
                            navigate(`/partner-detail/${pId}`);
                          }
                        }}
                      >
                        {user?.partnerId?.hostName || user?.partnerId?.companyName || user?.partnerId?.name || "View Partner"}
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>
                ) : null}
                {activeTab === "host" ? <td>{user?.plan?.name ? user?.plan?.name : "_"}</td> : ""}
                <td>
                  {new Date(user.createdAt).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "long",
                    year: "numeric",
                  })}
                </td>

                {activeTab === "host" && userType === "users" ? <td>{user?.isCreatedByAdmin ? "Admin" : (user?.name || user?.hostName || "—")}</td> : ""}


                {activeTab === "guest" && (
                  <td>
                    {(() => {
                      const validHosts = (user?.hosts || []).filter(
                        (item) => getHostName(item) !== null
                      );
                      return validHosts.length > 0 ? (
                        <Button
                          size="sm"
                          variant="outline-danger"
                          onClick={() => {
                            setGuestHosts(user.hosts);
                            setSelectedGuestName(user.name || user.hostName || "Guest");
                            setShowHostModal(true);
                          }}
                        >
                          View Hosts ({validHosts.length})
                        </Button>
                      ) : (
                        "_"
                      );
                    })()}
                  </td>
                )}



                {activeTab === "host" ? <td onClick={() => {
                  navigate(`/user-details/${user._id}`, {
                    state: { user },
                  });
                }}>
                  <Eye size={16} className="eye-icon" />
                </td> : ""}
                <td>
                  {activeTab === "host" ? <Dropdown>
                    <Dropdown.Toggle
                      variant="info light"
                      className="light sharp btn btn-info i-false"
                    >
                      {svg1}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {/* <Dropdown.Item
                        onClick={() => {
                          navigate(`/user-details/${user._id}`, {
                            state: { user },
                          });
                        }}
                      >
                        View
                      </Dropdown.Item> */}


                      {activeTab === "host" && (
                        <Dropdown.Item
                          onClick={() => {
                            if (user?.isBlocked) {
                              handleUnblockComponent(user?._id);
                              setIsBlocked(false);
                            } else {
                              setDeleteAccount(true);
                              setJobId(user?._id);
                              setIsBlocked(true);
                            }
                          }}
                        >
                          {user?.isBlocked ? "Unblock" : "Block"}
                        </Dropdown.Item>
                      )}

                      {/* {activeTab === "host" && (
                        <Dropdown.Item onClick={() => {
                          setSelectedUser(user);
                          setShowCoHostModal(true);
                        }}
                        >
                          Make Co-host
                        </Dropdown.Item>
                      )} */}

                      {activeTab === "host" && (
                        <>
                          <Dropdown.Item
                            onClick={() => {
                              setSelectedUserForPlan(user);
                              setAssignPlanId(user?.plan?._id || user?.plan?.id || "");
                              setPlanModalType("upgrade");
                              setShowAssignPlanModal(true);
                            }}
                          >
                            Upgrade Plan
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                            onClick={() => {
                              setSelectedUserForPlan(user);
                              setAssignPlanId(user?.plan?._id || user?.plan?.id || "");
                              setPlanModalType("newWedding");
                              setShowAssignPlanModal(true);
                            }}
                          >
                            New Wedding Request
                          </Dropdown.Item> */}
                        </>
                      )}


                    </Dropdown.Menu>
                  </Dropdown> : ""}

                </td>

              </tr>
            ))}
          </tbody>
        </Table>
        {data?.length > 0 && (
          <Pagination
            pageCount={totalPages}
            pageValue={currentPage}
            setPage={setCurrentPage}
            total={totalItems}
            pageSize={itemsPerPage}
          />
        )}
      </Card.Body>
    </Card>
  );


  // Yup Validation Schema
  const CoHostSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      .required("Phone number is required"),

    name: Yup.string()
      .required("Name is required")
  });

  // Handle submit for Co-host form
  const handleAddCoHost = async (values, { resetForm }) => {
    try {
      await addCohost(values)
      toast.success("Co-host added successfully!");
      setShowCoHostModal(false);
      setSelectedUser(null)
      resetForm();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to add co-host.");
    }
  };

  // Handle submit for Add Host form
  const handleAddHostSubmit = async (values, { resetForm, setSubmitting }) => {
    try {
      const payload = {
        hostName: values.hostName,
        groomName: values.groomName,
        brideName: values.brideName,
        hostSide: values.hostSide,
        countryCode: values.countryCode || "+91",
        phoneNumber: values.phoneNumber,
        subscriptionId: values.planId,
      };
      await createHost(payload);
      toast.success("Host added successfully!");
      setShowAddHostModal(false);
      resetForm();
      handleTableList();
    } catch (error) {
      console.error("Error creating host:", error);
      toast.error(error?.response?.data?.message || "Failed to add host");
    } finally {
      setSubmitting(false);
    }
  };

  // Handle submit for Assign Plan
  const handleAssignPlanSubmit = async (e) => {
    e.preventDefault();
    if (!assignPlanId) {
      toast.error("Please select a plan");
      return;
    }
    try {
      setAssignPlanLoading(true);
      const userId = selectedUserForPlan?._id || selectedUserForPlan?.id;
      await changeRequestUserPlan({
        userId,
        subscriptionId: assignPlanId,
      });
      toast.success("Plan assigned successfully!");
      setShowAssignPlanModal(false);
      setSelectedUserForPlan(null);
      setAssignPlanId("");
      handleTableList();
    } catch (error) {
      console.error("Error assigning plan:", error);
      toast.error(error?.response?.data?.message || "Failed to assign plan");
    } finally {
      setAssignPlanLoading(false);
    }
  };

  // Handle submit for New Wedding Request
  const handleNewWeddingRequestSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!assignPlanId) {
      toast.error("Please select a plan");
      return;
    }
    try {
      setNewWeddingLoading(true);
      const userId = selectedUserForPlan?._id || selectedUserForPlan?.id;
      await postNewWeddingRequest({
        userId,
        subscriptionId: assignPlanId,
      });
      toast.success("New wedding request submitted successfully!");
      setShowAssignPlanModal(false);
      setSelectedUserForPlan(null);
      setAssignPlanId("");
      handleTableList();
    } catch (error) {
      console.error("Error submitting new wedding request:", error);
      toast.error(error?.response?.data?.message || "Failed to submit new wedding request");
    } finally {
      setNewWeddingLoading(false);
    }
  };

  return (
    <div className="mt-5">
      <div className="pb-2   justify-content-between" style={{ gap: "10px" }}>


        <div className="mb-2 position-relative d-flex justify-content-between align-items-center gap-3">
          <div className="position-relative flex-grow-1">
            <input
              type="text"
              className="form-control inpp pe-5"
              style={{ borderRadius: "0.5rem" }}
              placeholder="Search by name, phone-number"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            {search && (
              <button
                type="button"
                onClick={() => setSearch("")}
                className="btn position-absolute top-50 end-0 translate-middle-y me-2"
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "1.2rem",
                  cursor: "pointer",
                }}
              >
                ❌
              </button>
            )}
          </div>
          {activeTab === "host" && (
            <Button
              style={{
                backgroundColor: "#A60000",
                borderColor: "#A60000",
                color: "#FFB101",
                fontWeight: "800",
                borderRadius: "0.5rem",
                whiteSpace: "nowrap",
                padding: "0.5rem 1.2rem",
              }}
              onClick={() => setShowAddHostModal(true)}
            >
              + Add New Host
            </Button>
          )}
        </div>

        <Card className="p-3 shadow-sm mb-4" style={{ borderRadius: "15px", background: "#f8f9fa", border: "1px solid #e9ecef" }}>
          <Row className="g-2 align-items-end">
            {activeTab === "host" && (
              <Col lg={true} md={4} sm={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold mb-1 small text-nowrap" style={{ color: "#800001" }}>
                    Filter by Plan
                  </Form.Label>
                  <Form.Select
                    size="sm"
                    value={sortByPlan}
                    onChange={(e) => setSortByPlan(e.target.value)}
                    style={{ borderRadius: "8px", height: "38px" }}
                  >
                    <option value="">All Plans</option>
                    {subscriptions?.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            <Col lg={true} md={4} sm={6}>
              <Form.Group>
                <Form.Label className="fw-semibold mb-1 small text-nowrap" style={{ color: "#800001" }}>
                  Start Date
                </Form.Label>
                <Form.Control
                  type="date"
                  size="sm"
                  value={filterDate}
                  onChange={(e) => setFilterDate(e.target.value)}
                  style={{ borderRadius: "8px", height: "38px" }}
                />
              </Form.Group>
            </Col>

            <Col lg={true} md={4} sm={6}>
              <Form.Group>
                <Form.Label className="fw-semibold mb-1 small text-nowrap" style={{ color: "#800001" }}>
                  End Date
                </Form.Label>
                <Form.Control
                  type="date"
                  size="sm"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  style={{ borderRadius: "8px", height: "38px" }}
                />
              </Form.Group>
            </Col>

            {activeTab === "host" && (
              <Col lg={true} md={4} sm={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold mb-1 small text-nowrap" style={{ color: "#800001" }}>
                    Filter by User Type
                  </Form.Label>
                  <Form.Select
                    size="sm"
                    value={userType}
                    onChange={(e) => setUserType(e.target.value)}
                    style={{ borderRadius: "8px", height: "38px" }}
                  >
                    <option value="users">All Hosts</option>
                    <option value="partnerHost">Host Created By Partner </option>
                    <option value="createdByAdmin">Hosts Created By Admin</option>

                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            <Col lg={true} md={4} sm={6} className="d-flex align-items-end">
              {(filterDate || endDate || sortByPlan || sortStatus || sortBy || search || (userType && userType !== "users")) ? (
                <button
                  className="btn btn-outline-danger w-100 fw-semibold btn-sm"
                  style={{ borderRadius: "8px", height: "38px" }}
                  onClick={() => {
                    setFilterDate("");
                    setEndDate("");
                    setSearch("");
                    setSortByPlan("");
                    setSortStatus("");
                    setSortBy("");
                    setSortOrder("asc");
                    setUserType("users");
                    setCurrentPage(0);
                  }}
                >
                  Clear Filters
                </button>
              ) : null}
            </Col>
          </Row>
        </Card>
      </div>
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3"
      >
        <Tab eventKey="host" title="Host List">
          <Col>
            {loader ? (
              <div>
                <Lottie
                  style={{
                    height: "200px",
                    marginTop: "45px",
                    padding: "30px",
                  }}
                  animationData={animationData}
                />
              </div>
            ) : tableData && tableData?.length > 0 ? (
              renderTable(tableData)
            ) : (
              <div style={{ height: "40vh" }} className="d-flex flex-column justify-content-center align-items-center py-5 text-center">
                <p style={{ color: "#A60000", textAlign: "center" }}>
                  Data not found
                </p>
              </div>
            )}
          </Col>
        </Tab>


        <Tab eventKey="guest" title="Guest List">
          <Col>




            {loader ? (
              <div>
                <Lottie
                  style={{
                    height: "200px",
                    marginTop: "45px",
                    padding: "30px",
                  }}
                  animationData={animationData}
                />
              </div>
            ) : guestList && guestList?.length > 0 ? (
              renderTable(guestList)
            ) : (
              <div className="justify-content-center d-flex my-5 fw-bold text-danger">
                Sorry, data not found!
              </div>
            )}
          </Col>
        </Tab>
      </Tabs>

      <ConfirmationDeleteAccount
        show={deleteAccount}
        onHide={() => setDeleteAccount(false)}
        onDelete={handleBlockComponent}
        type="user"
      />


      <Modal show={showCoHostModal} onHide={() => setShowCoHostModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Make Co-host</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{ phoneNumber: "", hostId: selectedUser?._id, countryCode: "+91", name: "" }}
          validationSchema={CoHostSchema}
          onSubmit={handleAddCoHost}
        >
          {({ handleSubmit, values, setFieldValue }) => (
            <FormikForm onSubmit={handleSubmit}>
              <Modal.Body>
                <Form.Group>
                  <Form.Label>Name</Form.Label>
                  <Field
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="eg. John Doe"
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger mt-1"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                  <PhoneInput
                    country={"in"}
                    onlyCountries={["in"]}
                    disableDropdown={true}
                    countryCodeEditable={false}
                    value={values.countryCode + values.phoneNumber}
                    onChange={(value, country) => {
                      const dialCode = `+${country?.dialCode || "91"}`;
                      const rawDial = country?.dialCode || "91";
                      const number = value.startsWith(rawDial)
                        ? value.slice(rawDial.length)
                        : value.replace(rawDial, "");
                      setFieldValue("countryCode", dialCode);
                      setFieldValue("phoneNumber", number);
                    }}
                    inputStyle={{
                      width: "100%",
                      height: "40px",
                    }}
                  />
                  <ErrorMessage
                    name="phoneNumber"
                    component="div"
                    className="text-danger mt-1"
                  />
                </Form.Group>

              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowCoHostModal(false)}>
                  Cancel
                </Button>
                <Button variant="primary" type="submit">
                  Make Co-host
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>


      <Modal
        show={showHostModal}
        onHide={() => setShowHostModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "maroon" }}>
            Hosts of {selectedGuestName}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {(() => {
            const validHosts = (guestHosts || []).filter(
              (item) => getHostName(item) !== null
            );
            return validHosts.length > 0 ? (
              <Table bordered responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Host Name</th>
                  </tr>
                </thead>
                <tbody>
                  {validHosts.map((host, index) => {
                    const hName = getHostName(host);
                    const hostId = host?.host?._id || host?._id;
                    return (
                      <tr key={hostId || index}>
                        <td>{index + 1}</td>
                        <td
                          className="cursor-pointer text-blue"
                          onClick={() => hostId && navigate(`/user-details/${hostId}`)}
                        >
                          {hName}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            ) : (
              <div
                style={{ height: "40vh" }}
                className="d-flex flex-column justify-content-center align-items-center py-5 text-center"
              >
                <p style={{ color: "#A60000", textAlign: "center" }}>
                  Data not found
                </p>
              </div>
            );
          })()}
        </Modal.Body>


      </Modal>

      <ConfirmDeleteModal
        show={showDeleteModal}
        onHide={() => {
          setShowDeleteModal(false);
          setDeleteId(null);
        }}
        onConfirm={handleDelete}
        loading={deleting}
        title="Delete Host"
        message="Are you sure you want to delete this host? This action cannot be undone."
      />

      {/* Add New Host Modal */}
      <Modal show={showAddHostModal} onHide={() => setShowAddHostModal(false)} centered size="lg">
        <Modal.Header closeButton style={{ backgroundColor: "#FFF6E5", borderBottom: "2px solid #F8DBA0" }}>
          <Modal.Title style={{ color: "#800001", fontWeight: "800" }}>
            Add New Host
          </Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            hostName: "",
            groomName: "",
            brideName: "",
            hostSide: "groom",
            countryCode: "+91",
            phoneNumber: "",
            planId: "",
          }}
          validationSchema={Yup.object({
            hostName: Yup.string().required("Host Name is required"),
            groomName: Yup.string().required("Groom Name is required"),
            brideName: Yup.string().required("Bride Name is required"),
            hostSide: Yup.string().required("Host Side is required"),
            phoneNumber: Yup.string()
              .matches(/^[0-9]{10}$/, "Phone Number must be 10 digits")
              .required("Phone Number is required"),
            planId: Yup.string().required("Subscription Plan is required"),
          })}
          onSubmit={handleAddHostSubmit}
        >
          {({ isSubmitting }) => (
            <FormikForm>
              <Modal.Body className="p-4">
                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label style={{ color: "#800001", fontWeight: "700" }}>Host Name *</Form.Label>
                      <Field
                        name="hostName"
                        type="text"
                        className="form-control"
                        placeholder="Enter Host Name"
                        style={{ borderColor: "#F8DBA0", borderRadius: "0.75rem" }}
                      />
                      <ErrorMessage name="hostName" component="div" className="text-danger small mt-1" />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label style={{ color: "#800001", fontWeight: "700" }}>Groom Name *</Form.Label>
                      <Field
                        name="groomName"
                        type="text"
                        className="form-control"
                        placeholder="Enter Groom Name"
                        style={{ borderColor: "#F8DBA0", borderRadius: "0.75rem" }}
                      />
                      <ErrorMessage name="groomName" component="div" className="text-danger small mt-1" />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label style={{ color: "#800001", fontWeight: "700" }}>Bride Name *</Form.Label>
                      <Field
                        name="brideName"
                        type="text"
                        className="form-control"
                        placeholder="Enter Bride Name"
                        style={{ borderColor: "#F8DBA0", borderRadius: "0.75rem" }}
                      />
                      <ErrorMessage name="brideName" component="div" className="text-danger small mt-1" />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label style={{ color: "#800001", fontWeight: "700" }}>Host Side *</Form.Label>
                      <Field
                        as="select"
                        name="hostSide"
                        className="form-select"
                        style={{ borderColor: "#F8DBA0", borderRadius: "0.75rem" }}
                      >
                        <option value="groom">Groom</option>
                        <option value="bride">Bride</option>
                      </Field>
                      <ErrorMessage name="hostSide" component="div" className="text-danger small mt-1" />
                    </Form.Group>
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Group>
                      <Form.Label style={{ color: "#800001", fontWeight: "700" }}>Phone Number *</Form.Label>
                      <Field
                        name="phoneNumber"
                        type="text"
                        maxLength={10}
                        className="form-control"
                        placeholder="Enter 10 digit phone number"
                        style={{ borderColor: "#F8DBA0", borderRadius: "0.75rem" }}
                      />
                      <ErrorMessage name="phoneNumber" component="div" className="text-danger small mt-1" />
                    </Form.Group>
                  </Col>

                  <Col md={12} className="mb-3">
                    <Form.Group>
                      <Form.Label style={{ color: "#800001", fontWeight: "700" }}>Select Subscription Plan *</Form.Label>
                      <Field
                        as="select"
                        name="planId"
                        className="form-select"
                        style={{ borderColor: "#F8DBA0", borderRadius: "0.75rem" }}
                      >
                        <option value="">-- Select Subscription Plan --</option>
                        {subscriptions?.map((plan) => (
                          <option key={plan._id || plan.id} value={plan._id || plan.id}>
                            {plan?.name} {plan?.price !== undefined ? `(₹${plan.price})` : ""}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage name="planId" component="div" className="text-danger small mt-1" />
                    </Form.Group>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer style={{ borderTop: "1px solid #F8DBA0" }}>
                <Button variant="secondary" onClick={() => setShowAddHostModal(false)} disabled={isSubmitting}>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  style={{ backgroundColor: "#A60000", borderColor: "#A60000", color: "#FFB101", fontWeight: "800" }}
                  disabled={isSubmitting}
                >
                  Add Host
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>

      {/* ASSIGN / UPGRADE / NEW WEDDING PLAN MODAL */}
      <Modal
        show={showAssignPlanModal}
        onHide={() => {
          setShowAssignPlanModal(false);
          setSelectedUserForPlan(null);
          setAssignPlanId("");
        }}
        centered
      >
        <Modal.Header closeButton style={{ borderBottom: "1px solid #F8DBA0" }}>
          <Modal.Title style={{ color: "#800001", fontWeight: "700" }}>
            {planModalType === "newWedding" ? "New Wedding Request" : "Upgrade Plan"} - {selectedUserForPlan?.name || selectedUserForPlan?.hostName}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={planModalType === "newWedding" ? handleNewWeddingRequestSubmit : handleAssignPlanSubmit}>
          <Modal.Body className="py-4">
            {selectedUserForPlan?.plan?.name && (
              <p className="mb-3 text-secondary">
                Current Plan: <strong>{selectedUserForPlan.plan.name}</strong>
              </p>
            )}
            <Form.Group className="mb-3">
              <Form.Label style={{ color: "#800001", fontWeight: "700" }}>
                Select Subscription Plan *
              </Form.Label>
              <Form.Select
                value={assignPlanId}
                onChange={(e) => setAssignPlanId(e.target.value)}
                style={{ borderColor: "#F8DBA0", borderRadius: "0.75rem" }}
                required
              >
                <option value="">-- Select Subscription Plan --</option>
                {subscriptions?.map((plan) => (
                  <option key={plan._id || plan.id} value={plan._id || plan.id}>
                    {plan?.name} {plan?.price !== undefined ? `(₹${plan.price})` : ""}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "1px solid #F8DBA0" }}>
            <Button
              variant="secondary"
              onClick={() => {
                setShowAssignPlanModal(false);
                setSelectedUserForPlan(null);
                setAssignPlanId("");
              }}
              disabled={assignPlanLoading || newWeddingLoading}
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: "#A60000", borderColor: "#A60000", color: "#FFB101", fontWeight: "800" }}
              type="submit"
              disabled={assignPlanLoading || newWeddingLoading}
            >
              {planModalType === "newWedding"
                ? (newWeddingLoading ? "Submitting..." : "Send Request")
                : (assignPlanLoading ? "Upgrading..." : "Upgrade Plan")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}
